import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';

/**
 * Backup if public/index.html script did not run (e.g. alternate HTML template).
 * Primary handler is inline in index.html so it registers before webpack dev overlay.
 */
if (typeof window !== 'undefined') {
  const isBenignResizeObserverMsg = (text) =>
    typeof text === 'string' && /resizeobserver\s+loop/i.test(text);

  window.addEventListener(
    'error',
    (e) => {
      if (isBenignResizeObserverMsg(e?.message ?? '')) {
        e.stopImmediatePropagation();
        if (typeof e.preventDefault === 'function') e.preventDefault();
      }
    },
    true,
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals 